//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return {
            patientname: '',
            sex: '',
            birthday: '',
            idnumber: '',
            birthday: '',
            price: this.$store.state.price
        }
    },
    created(){
        document.title = '完善信息';
        
    },
    methods: {
        change(v){
            this.birthday = v
        },
        add(){
            if(this.patientname == null || this.patientname == ''){
                this.$toastMsg('请输入患者姓名');
                return;
            }
            if(this.sex == null || this.sex == ''){
                this.$toastMsg('请选择性别');
                return;
            }
            if(this.birthday == null || this.birthday == ''){
                this.$toastMsg('请选择生日日期');
                return;
            }
            var data = {
                patientname: this.patientname,
                sex: this.sex,
                birthday: this.birthday,
                idnumber: this.idnumber,
                telephone: this.$route.query.tel,

            }
            this.$doRequest('/api/Personal/ghregister', data, res=>{
                var datas = {
                    doctorid: this.$store.state.doctorId,
                    patientid: res.parameters,
                    hospitainid: this.$store.state.clinicId
                }
                var ua = navigator.userAgent.toLowerCase();
                if(ua.match(/MicroMessenger/i)=="micromessenger") {
                    datas.wptype = 'jsapi';
                    datas.openid=this.$store.state.openid;
                } else {
                    datas.wptype = 'h5';
                }
                var resc=res;
                this.$doRequest('/api/diagnosisqueue/wxpay', datas ,res=>{
                    if(datas.wptype == 'jsapi'){
                        if(this.$store.state.free){
                            location.href = res.parameters;
                        }else{
                            WeixinJSBridge.invoke('getBrandWCPayRequest', res.parameters,ress=>{
                                if (ress.err_msg == "get_brand_wcpay_request:ok") {
                                    this.$router.push({path: '/systemRegistered/payResult', query: {type: 0,patientid: resc.parameters}});
                                } else {
                                    this.$toastMsg("支付失败");
                                }
                            });
                        }
                    }else if(datas.wptype == 'h5'){
                        if(this.$store.state.free){
                            location.href = res.parameters;
                        }else{
                            sessionStorage.setItem('doctorid',this.$store.state.doctorId);
                            sessionStorage.setItem('hospitainid',this.$store.state.clinicId);
                            sessionStorage.setItem('patientid',resc.parameters)
                            location.href = res.parameters + '&redirect_url=http://hzyh5.51bjhzy.com/systemRegistered/payResult';
                        }
                    }
                })
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/systemRegistered/perfectInformation/index.vue